$(document).ready(function() {

  // Create (non active) radio button elements in forms
  $('.modal .form-check input[type="radio"]').on('change', function() {

    if ($('fieldset.clearance').length) {
      var whichSection = 'clearance';
      $('fieldset.document-dates').removeClass('d-none');
    }

    if ($('fieldset.qualification').length) {
      var whichSection = 'qualification';
      $('fieldset.qualification-details').removeClass('d-none');
      $('fieldset.qualification .input-group.issue-date').removeClass('d-none');
    }

    if ($('fieldset.'+whichSection+' input[type="radio"]').length == 0) {
      var $clone = $(this).parent().clone();
      $clone.prependTo($('fieldset.'+whichSection));
    } else {
      $('fieldset.'+whichSection+' input[type="radio"]').parent().remove();
      var $clone = $(this).parent().clone();
      $clone.prependTo($('fieldset.'+whichSection));
    }

    $('.js-bttn-add-'+whichSection).addClass('d-none');

    $('.card.card-file-with-input .form-control').attr('disabled', false);

  });

});
